<template>
    <div class="page-content">

        <div id="presskit" class="section bg-svg-forestlake">
            <div class="overlay opacity-35"></div>
            <lottie-player
                autoplay
                loop
                mode="normal"
                preserveAspectRatio="xMidYMid slice"
                src="https://cdn.sleepjar.com/sleepsounds/images/backgrounds/7x3/animated/simple/json/ForestMountainLake.json"
                class="bg-lottie-player"
            />
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">

                        <h1 class="title color-white mb-5">Press Kit</h1>

                        <p class="lead mb-5">Publishing a story about us? Please use these official brand assets.</p>

                        <div class="mb-5">
                            <div class="col-md-12 ml-auto mr-auto">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="floater jumbotron bg-white">
                                            <img class="card-img brand-preview" src="/images/logo/main_horiz_purp.svg">
                                            <div class="card-body">
                                                <a href="/images/logo/main_horiz_purp.svg" class="btn btn-primary" download><i class="fa fa-download mr-1"></i> Logo (purple)</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="floater jumbotron">
                                            <img class="card-img brand-preview" src="/images/logo/main_horiz_white.svg">
                                            <div class="card-body">
                                                <a href="/images/logo/main_horiz_white.svg" class="btn btn-light" download><i class="fa fa-download mr-1"></i> Logo (white)</a>
                                            </div>
                                        </div>
                                    </div>
                                    <!--
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="floater jumbotron bg-white">
                                            <img class="card-img brand-preview" src="/images/logo/jar_purp.svg">
                                            <div class="card-body">
                                                <a href="/images/logo/jar_purp.svg" class="btn btn-light" download><i class="fa fa-download mr-1"></i> Jar (purple)</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="floater jumbotron">
                                            <img class="card-img brand-preview" src="/images/logo/jar_white.svg">
                                            <div class="card-body">
                                                <a href="/images/logo/jar_white.svg" class="btn btn-light" download><i class="fa fa-download mr-1"></i> Jar (white)</a>
                                            </div>
                                        </div>
                                    </div>
                                    -->
                                </div>
                            </div>
                        </div>

                        <p class="lead">For partnership and licensing inquiries, please email <a href="mailto:partnerships@sleepjar.com" class="underline">partnerships@sleepjar.com</a>.</p>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <div id="publications" class="section grow bg-svg-beach">
            <div class="overlay opacity-50"></div>

            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Featured Publications</h1>

                        <p class="lead mb-5">We're honored to be mentioned in these articles.</p>

                        <div class="col-md-12 ml-auto mr-auto">
                            <div class="row">
                                <table class="table table-responsive-md text-left">
                                    <thead>
                                        <tr>
                                            <th width="120px">Date</th>
                                            <th>Title</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>12/9/2020</td>
                                            <td><a href="https://www.gearbrain.com/best-tech-to-help-sleep-2596150585.html" target="_blank">GearBrain: The Best Tech to Help You Sleep</a></td>
                                        </tr>
                                        <tr>
                                            <td>8/4/2020</td>
                                            <td><a href="https://www.wired.com/gallery/best-sound-machines/" target="_blank">Wired: The Best Sound Machines for a Blissful Night's Sleep</a></td>
                                        </tr>
                                        <tr>
                                            <td>9/4/2019</td>
                                            <td><a href="https://bixby.developer.samsung.com/newsroom/en-us/Premier-Developer-Invoked-Apps-Sleep-soundly-rest-assured" target="_blank">Samsung: Sleep Soundly, Rest Assured</a></td>
                                        </tr>
                                        <tr>
                                            <td>7/6/2019</td>
                                            <td><a href="https://www.foxnews.com/tech/7-alexa-skills-youll-use-time-and-time-again" target="_blank">Fox News: 7 Alexa Skills You'll Use Time and Time Again</a></td>
                                        </tr>
                                        <tr>
                                            <td>5/7/2019</td>
                                            <td><a href="https://www.cnn.com/2019/05/06/tech/amazon-alexa-skills-blueprints/index.html" target="_blank">CNN: Amazon Alexa Side Hustle</a></td>
                                        </tr>
                                        <tr>
                                            <td>8/17/2018</td>
                                            <td><a href="https://www.cnet.com/how-to/the-first-alexa-skills-you-should-enable/" target="_blank">CNET: These are the first 7 Alexa skills you should enable</a></td>
                                        </tr>
                                        <tr>
                                            <td>5/25/2018</td>
                                            <td><a href="https://www.androidauthority.com/best-skills-and-apps-for-alexa-869243/" target="_blank">Android Authority: 10 best skill and apps for Alexa</a></td>
                                        </tr>
                                        <tr>
                                            <td>11/7/2017</td>
                                            <td><a href="https://arstechnica.com/gadgets/2017/11/amazon-echo-2017-review-better-price-better-alexa-just-ok-sound/" target="_blank">Ars Technica: Amazon Echo Review</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->

    </div>
</template>

<script>
export default {
    data () {
        return {
        };
    },
    name: 'press',
    metaInfo: {
        title: 'Press',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Resources for press and brand partners.'
            }
        ]
    },
    methods: {
    },
    computed: {
    },
    components: {
    },
    mounted(){
    }
}
</script>
